var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33333C16.7037 3.33333 13.4814 4.31082 10.7405 6.14217C7.99973 7.97353 5.86353 10.5765 4.60206 13.6219C3.34059 16.6673 3.01054 20.0185 3.65363 23.2515C4.29671 26.4845 5.88406 29.4542 8.21494 31.7852C10.5458 34.116 13.5155 35.7033 16.7485 36.3465C19.9815 36.9895 23.3327 36.6595 26.378 35.398C29.4235 34.1365 32.0265 32.0003 33.8579 29.2595C35.6892 26.5187 36.6667 23.2963 36.6667 20C36.6667 17.8113 36.2355 15.644 35.398 13.6219C34.5605 11.5998 33.3329 9.76253 31.7852 8.21488C30.2375 6.66725 28.4002 5.43958 26.378 4.602C24.356 3.76443 22.1887 3.33333 20 3.33333ZM20 33.3333C17.363 33.3333 14.7851 32.5513 12.5924 31.0863C10.3998 29.6212 8.69083 27.5388 7.68166 25.1025C6.67249 22.6662 6.40844 19.9852 6.92291 17.3988C7.43738 14.8124 8.70726 12.4366 10.572 10.5719C12.4367 8.70722 14.8124 7.43733 17.3989 6.92287C19.9852 6.4084 22.6662 6.67243 25.1025 7.6816C27.5389 8.69078 29.6212 10.3997 31.0864 12.5924C32.5514 14.785 33.3334 17.3628 33.3334 20C33.3294 23.535 31.9234 26.924 29.4237 29.4237C26.924 31.9233 23.535 33.3293 20 33.3333ZM18.9959 20.9203L15.4427 17.3682L13.4409 19.3717L18.9959 24.9275L26.8717 17.0523L24.8699 15.0488L18.9959 20.9203Z",
    fill: "#9F9978"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.18670ce37d028181c157d370001b0cfa.svg";
export { ForwardRef as ReactComponent };